import React, { useEffect, useMemo, useState } from 'react';
import Container from '../components/Container';
import TableTitle from '../components/TableTitle';
import { Table } from '../components/Table';
import Modal from '../components/Modal';
import { InvitationForm, useInvitationsStore } from '../features/invitation';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import HowToRegRoundedIcon from '@mui/icons-material/HowToRegRounded';
import { useRolesStore } from '../features/invitation/state/use-roles-store';

const Invitation = () => {
  const [showModal, setShowModal] = useState(false);
  const { data, isLoading, error, fetchInvitations } = useInvitationsStore();
  const { fetchRoles, rolesDict } = useRolesStore();

  useEffect(() => {
    const fetch = async () => {
      await Promise.all([fetchInvitations(), fetchRoles()]);
    };
    fetch();
  }, []);

  const columns = useMemo(
    () => [
      {
        key: 'email',
        title: 'Email',
      },
      {
        key: 'role',
        title: 'Роль',
        render: (value) => <div>{rolesDict[value] ?? value}</div>,
      },
      {
        key: 'status',
        title: 'Статус',
        render: (value) => (
          <div className={'flex items-center gap-x-2'}>
            {value === 'sent' ? (
              <>
                <HourglassEmptyIcon fontSize="small" className={'text-orange-500'} />
                <span>Приглашение отправлено</span>
              </>
            ) : (
              <>
                <HowToRegRoundedIcon fontSize="small" color="success" />
                <span>Регистрация завершена</span>
              </>
            )}
          </div>
        ),
      },
    ],
    [rolesDict]
  );

  return (
    <Container>
      <TableTitle containerClass={'max-w-7xl mx-auto'} title={'Отправленные приглашения'} handlerAddButton={() => setShowModal(true)} />
      <Table columns={columns} data={data} loading={isLoading} error={error} />
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        title="Добавить инженера"
        showSave={false}
        error={null}
        classWidth="relative w-full max-w-[500px] my-6 mx-2">
        <InvitationForm closeModal={() => setShowModal(false)} />
      </Modal>
    </Container>
  );
};
export default Invitation;
